import actions from '../../../../sharedmodules/actions-list';

export const resetPinPlateData = () => ({
    type: actions.RESET_PIN_PLATE_REQUEST_DATA,
});
